import { useEffect, useState } from 'react';
import * as BREAKPOINTS from '../breakpoints.js';
export const useWindowResize = () => {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });
    const isMobileDevice = BREAKPOINTS.isBrowserMobileView(width);
    const isTabletDevice = BREAKPOINTS.isBrowserTabletView(width);
    const isDesktopDevice = BREAKPOINTS.isBrowserDesktopView(width);
    const isTouchDevice = BREAKPOINTS.isBrowserTouchView(width);
    return {
        width,
        isTouchDevice,
        isMobileDevice,
        isTabletDevice,
        isDesktopDevice
    };
};
//# sourceMappingURL=index.js.map